import {
  ENABLE_SAVE,
  DISABLE_SAVE,
} from './actionTypes';

export const enableSave = () => (dispatch) => {
  dispatch({
    type: ENABLE_SAVE,
  });
};

export const disableSave = () => (dispatch) => {
  dispatch({
    type: DISABLE_SAVE,
  });
};
